export const qrPayBanks = [
    {
        code: "DUITNOWQR",
        name: "Duitnow",
    },
    {
        code: "MBB",
        name: "Maybank",
    },
    {
        code: "TNG",
        name: "Touch 'n Go",
    },
    {
        code: "GRAB",
        name: "GrabPay",
    },
    {
        code: "BOOST",
        name: "Boost",
    }
]   